/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoContattoDTO
 */
export interface TipoContattoDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoContattoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TipoContattoDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the TipoContattoDTO interface.
 */
export function instanceOfTipoContattoDTO(value: object): value is TipoContattoDTO {
    return true;
}

export function TipoContattoDTOFromJSON(json: any): TipoContattoDTO {
    return TipoContattoDTOFromJSONTyped(json, false);
}

export function TipoContattoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoContattoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function TipoContattoDTOToJSON(value?: TipoContattoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
    };
}

